let audioContext: AudioContext | null = null;
type WebkitWindow = Window & typeof globalThis & { webkitAudioContext?: typeof AudioContext };

export const playSupportNotificationSound = () => {
  try {
    if (!audioContext) {
      const audioCtor = window.AudioContext || (window as WebkitWindow).webkitAudioContext;
      if (!audioCtor) {
        return;
      }
      audioContext = new audioCtor();
    }

    const now = audioContext.currentTime;
    const notes = [
      { frequency: 640, start: now, duration: 0.08 },
      { frequency: 820, start: now + 0.09, duration: 0.08 },
      { frequency: 720, start: now + 0.18, duration: 0.1 },
    ];

    notes.forEach((note) => {
      const oscillator = audioContext!.createOscillator();
      const gainNode = audioContext!.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(audioContext!.destination);

      oscillator.frequency.setValueAtTime(note.frequency, note.start);
      gainNode.gain.setValueAtTime(0.0001, note.start);
      gainNode.gain.exponentialRampToValueAtTime(0.18, note.start + 0.01);
      gainNode.gain.exponentialRampToValueAtTime(0.0001, note.start + note.duration);

      oscillator.start(note.start);
      oscillator.stop(note.start + note.duration);
    });
  } catch (error) {
    console.error("Failed to play support notification sound:", error);
  }
};
